import Alert from '@mui/material/Alert';
import { t } from 'i18next';

import { RutterConnection } from '~hooks/useRutter/models';

interface ManagedByOwnerAlertProps {
  connection: RutterConnection;
}

export default function ManagedByOwnerAlert({ connection }: ManagedByOwnerAlertProps) {
  return (
    <Alert
      data-test-id="managed-by-owner-alert"
      severity="info"
      sx={{ mb: 2 }}
      variant="outlined"
    >
      {t('administration.integration.rutter.managed_by_owner.alert', {
        company: connection.ownerCompany.legalName,
      })}
    </Alert>
  );
}
